import vue from 'vue'
import {
  getQuotationRecommend,
  getLastQuotation,
  getQuotationLabels,
  subQuotation, searchSubscribe,
  getQuotationTitle, getQuotationDetails,
  addQuotation, getQuotationSubscribe, unSubQuotation
} from "@/services/dynamic/dynamicHome";
import {Message} from "element-ui";


const state = {
  childMenu: vue.ls.get('childMenu'),
  addQuotationInfo: vue.ls.get('addQuotationInfo'),

  dataPages: [],//首页推荐
  total: 0,
  paginationInit: {current: 1, size: 10},
  filterInit: {},//推荐的
  filterDYInit: {},//订阅的

  mySubscribe: [],//我的订阅
  dataDetails: {},//根据ID获取详情
  myQuotation: {},//我的动态
  dataLast: {},//导入上次的报价单
  dataLabels: {},//标签
  dataTitle: {},//创建报价单表头
  subNumber: {},//查询订阅和被订阅人数
  addVisible: false,//添加报价信息弹窗
  editVisible: false,//编辑报价信息弹窗
};

const getters = {
  childMenu: () => state.childMenu ? state.childMenu : vue.ls.get('childMenu'),
  addQuotationInfo: () => state.addQuotationInfo ? state.addQuotationInfo : vue.ls.get('addQuotationInfo'),

  dataPages: () => state.dataPages,
  total: () => state.total,
  paginationInit: () => state.paginationInit,
  filterInit: () => state.filterInit,
  filterDYInit: () => state.filterDYInit,

  mySubscribe: () => state.mySubscribe,
  dataDetails: () => state.dataDetails,
  myQuotation: () => state.myQuotation,
  dataLast: () => state.dataLast,
  dataLabels: () => state.dataLabels,
  dataTitle: () => state.dataTitle,
  subNumber: () => state.subNumber,
  addVisible: () => state.addVisible,
  editVisible: () => state.editVisible,
};

const actions = {
  //财粮说首页推荐
  getQuotationRecommend({commit, dispatch}, objc) {
    getQuotationRecommend({...state.filterInit, ...state.paginationInit}).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'dataPages', update: res.data.records});
        commit('updateState', {state: 'total', update: res.data.total});
      } else {
        commit('updateState', {state: 'dataPages', update: []});
        commit('updateState', {state: 'total', update: 0});
      }
    })
  },
  //财粮说我的订阅
  getQuotationSubscribe({commit, dispatch}, objc) {
    getQuotationSubscribe({...state.filterDYInit}).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'mySubscribe', update: res.data});
      }
    })
  },

  //根基ID获取报价单详情
  getQuotationDetails({commit, dispatch}, objc) {
    getQuotationDetails(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'dataDetails', update: res.data});
      }
    })
  },

  //导入上一次的报价单
  getLastQuotation({commit, dispatch}, objc) {
    getLastQuotation(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'dataLast', update: res.data});
      }
    })
  },

  //创建报价单表格下拉框
  getQuotationTitle({commit, dispatch}, objc) {
    getQuotationTitle(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'dataTitle', update: res.data});
      }
    })
  },
  //获取标签
  getQuotationLabels({commit, dispatch}, objc) {
    getQuotationLabels(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'dataLabels', update: res.data});
      }
    })
  },
  //创建报价单
  addQuotation({commit, dispatch}, objc) {
    let obj = JSON.parse(JSON.stringify(objc.params))
    //处理时间
    if (obj.time && obj.time.length > 0) {
      obj.beginDate = obj.time[0] + ':00';
      obj.endDate = obj.time[1] + ':00';
      delete obj.time;
    }
    let arr = [];
    if (obj && obj.labelList && obj.labelList.length > 0) {
      obj.labelList.map((i) => {
        arr.push({label: i});
      })
    }
    addQuotation({...obj, labelList: arr}).then((res) => {
      if (res.code === 0) {
        if (objc.params.status == 0) {
          Message.success('保存草稿成功');
        }
        if (objc.params.status == 1) {
          Message.success('创建报价单成功!');
        }
        if (objc.route) {
          objc.route.go(-1);
        }
        commit('updateState', {state: 'addQuotationInfo', update: null})
      }
    })
  },

  //订阅报价单
  subQuotation({commit, dispatch}, objc) {
    subQuotation(objc.personId).then((res) => {
      if (res.code === 0) {
        dispatch('getQuotationDetails', objc.id)
      }
    })
  },
  //取消订阅报价单
  unSubQuotation({commit, dispatch}, objc) {
    unSubQuotation(objc.personId).then((res) => {
      if (res.code === 0) {
        dispatch('getQuotationDetails', objc.id)
      }
    })
  },
  //查询订阅和被订阅人数
  searchSubscribe({commit, dispatch}, objc) {
    searchSubscribe(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'subNumber', update: res.data});
      }
    })
  },

};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
    if (payload.state === 'childMenu' || payload.state == 'addQuotationInfo') {
      vue.ls.set(payload.state, payload.update);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/dynamic/modules/dynamicHome.js